import moment from "moment";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TwoBtnModal } from "components/common/modal";
import { delTableSetting } from "service/api/digital";
import routerConstant from "service/constant/routerConstant";
import type { ITableSetting } from "service/interface/digital";
import { KeyedMutator } from "swr";
import responseCodeConstant from "service/constant/responseCodeConstant";

interface Props {
  data: ITableSetting[];
  mutate: KeyedMutator<any>;
}

export function TableSettingListTable({ data, mutate }: Props) {
  const navigate = useNavigate();
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [selectDeleteId, setSelectDeleteId] = useState<number>(0);

  const handleTableClick = (id: number) => {
    navigate(`${routerConstant.TABLESETTING.index}/${id}`);
  };

  const handleDeleteBtn = (id: number) => {
    setSelectDeleteId(id);
    setIsDeleteModalVisible(true);
  };

  const handleDeleteModalBtn = async () => {
    const delRes = await delTableSetting(selectDeleteId + "");
    if (delRes.status === responseCodeConstant.SUCCESS.ok) {
      mutate();
    }
  };

  return (
    <>
      <TwoBtnModal
        isVisible={isDeleteModalVisible}
        setIsVisible={setIsDeleteModalVisible}
        title="해당 게시글을 삭제하시겠습니까?"
        subTitle=""
        btnLabel="삭제하기"
        btnClick={handleDeleteModalBtn}
      />
      <div className="w-ful">
        <table className="w-full divide-y divide-[#d1dff3]">
          <thead>
            <tr>
              <th
                scope="col"
                className="min-w-[71px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
              >
                ID
              </th>
              <th
                scope="col"
                className="min-w-[307px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
              >
                상차림 이미지
              </th>
              <th
                scope="col"
                className="min-w-[401px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
              >
                제목
              </th>
              <th
                scope="col"
                className="min-w-[140px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
              >
                생성일
              </th>
              <th
                scope="col"
                className="min-w-[104px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
              >
                편집
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {data.map((table) => (
              <tr
                key={table.id}
                className="cursor-pointer even:bg-[#fbfbfb] hover:bg-blue-2"
                onClick={() => handleTableClick(table.id)}
              >
                <td className="h-[106px] whitespace-nowrap px-[15px] py-[16px] text-M1 text-gray-5">
                  {table.id}
                </td>
                <td className="h-[106px]whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                  <img
                    src={table.imgSrc}
                    alt="table screen img"
                    className="max-h-[74px] max-w-[227px]"
                  />
                </td>
                <td className="h-[106px] whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                  {table.title}
                </td>
                <td className="h-[106px] whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                  {moment(table.createdAt).format("YYYY-MM-DD")}
                </td>
                <td
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteBtn(table.id);
                  }}
                  className="h-[106px] cursor-pointer whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5"
                >
                  삭제
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
